import React from 'react'
import { encode, decode } from './Store'


let SignIn = ({ children, forward_path }) =>
	<a href={`/sso/?forward_path=${forward_path ? encode(forward_path) : encode(window.location.pathname)}`}>
		{children}
	</a>


export default SignIn
